import { Result } from 'src/models/Result.model';
import { EyesPosition, Session } from 'src/models/Session.model';

const checkIsGradable = (results: Result[]) => {
  return !results.some(
    (res) =>
      res === undefined || res.error !== undefined || res.gradable === false,
  );
};

export default function getGradingResult(session: Session) {
  const isLeftEyeGradable =
    !!session.leftResults?.length && checkIsGradable(session.leftResults);

  const isRightEyeGradable =
    !!session.rightResults?.length && checkIsGradable(session.rightResults);

  if (isLeftEyeGradable && isRightEyeGradable) {
    return EyesPosition.BOTH;
  }
  if (isLeftEyeGradable) {
    return EyesPosition.LEFT;
  }
  if (isRightEyeGradable) {
    return EyesPosition.RIGHT;
  }

  return undefined;
}
